export default __webpack_public_path__ + "static/media/icon-facebook.e9773e52.svg";